module.exports = __webpack_public_path__ + "img/avatar3.3e299849.png";